import { MouseEventHandler } from 'react';

import { Box } from '@aicon-dev/caas-core';
import { AiOutlineCheck } from 'react-icons/ai';
import styled, { css } from 'styled-components';

import { Close } from '~/assets/icons';

interface UploadingPhotoProps {
  url: string;
  handleClick: () => void;
  bottomText?: string;
  width?: string;
  height?: string;
  marginRight?: string;
  marginBottom?: string;
  paddingBottom?: string;
  checkIcon?: boolean;
}

export const CommentUploadPhoto = ({
  width,
  height,
  marginRight,
  marginBottom,
  paddingBottom,
  url,
  handleClick,
  bottomText,
  checkIcon,
}: UploadingPhotoProps) => {
  return (
    <Box
      position="relative"
      width={width || '72px'}
      height={height || '72px'}
      marginRight={marginRight || '8px'}
      marginBottom={marginBottom || '8px'}
      paddingBottom={paddingBottom || '0'}
      onClick={bottomText ? handleClick : undefined}
    >
      {!bottomText && <CloseButton onClick={handleClick} />}

      {checkIcon && (
        <Box
          position="absolute"
          top="-6px"
          right="-4px"
          zIndex={1}
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="1rem"
          height="1rem"
          color="white"
          fontSize="0.75rem"
          background="var(--color-primary-400)"
          borderRadius="100%"
        >
          <AiOutlineCheck />
        </Box>
      )}

      <SImg src={url} alt="" />

      {bottomText && (
        <Box textAlign="center" fontSize="12px" color="var(--grey-500)" maxWidth="72px">
          {bottomText}
        </Box>
      )}
    </Box>
  );
};

interface CloseButtonProps {
  onClick: MouseEventHandler<HTMLDivElement>;
}

export const CloseButton = ({ onClick }: CloseButtonProps) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="absolute"
      top="-4px"
      right="-4px"
      width="14px"
      height="14px"
      background="red"
      borderRadius="50%"
      onClick={onClick}
    >
      <Close size="8" color="white" />
    </Box>
  );
};

export const cssWorkPhotoSize = css`
  width: 72px;
  height: 72px;
`;

export const SImg = styled.img`
  ${cssWorkPhotoSize}
  border-radius: 4px;
  object-fit: cover;
  width: 100%;
`;
